var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 2.13882H12.625V17.861H21.375V2.13882Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1814 10C13.1814 6.80556 14.6814 3.97223 16.987 2.13889C15.2925 0.805559 13.1536 0 10.8203 0C5.29253 0 0.820312 4.47222 0.820312 10C0.820312 15.5278 5.29253 20 10.8203 20C13.1536 20 15.2925 19.1945 16.987 17.8611C14.6814 16.0556 13.1814 13.1944 13.1814 10Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1823 9.99994C33.1823 15.5277 28.7101 19.9999 23.1823 19.9999C20.849 19.9999 18.7101 19.1944 17.0156 17.8611C19.349 16.0277 20.8212 13.1944 20.8212 9.99994C20.8212 6.80549 19.3212 3.97216 17.0156 2.13883C18.7101 0.805498 20.849 -6.10352e-05 23.1823 -6.10352e-05C28.7101 -6.10352e-05 33.1823 4.49994 33.1823 9.99994Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard_logo.b0f3a08300f486c3e71e4dc7b9639d5e.svg";
export { ForwardRef as ReactComponent };